import * as Status from '../../../constants/status';

export const DEFAULT_STATUS = [
  Status.EM_CRIACAO,
  Status.AGUARDANDO_INSPECAO,
  Status.EM_INSPECAO,
  Status.INSPECAO_FINALIZADA,
  Status.INSPECAO_ENVIADA_PARCIAL,
];

export const DEFAULT_STATUS_OPTIONS = [
  { id: Status.EM_CRIACAO, nome: 'Em Criação' },
  { id: Status.AGUARDANDO_INSPECAO, nome: 'Aguardando Inspeção' },
  { id: Status.EM_INSPECAO, nome: 'Em Inspeção' },
  { id: Status.INSPECAO_FINALIZADA, nome: 'Inspeção Finalizada' },
  { id: Status.INSPECAO_ENVIADA_PARCIAL, nome: 'Inspeção Enviada Parcial' },
  { id: Status.FINALIZADA, nome: 'Finalizada' },
  { id: Status.CANCELADA, nome: 'Cancelado' },
];

export const EMPTY_FILTER = {
  malhaId: null,
  municipioIbge: null,
  status: DEFAULT_STATUS,
};

export const buildApiFilter = (filter) => {
  const apiFilter = { possuiCoordenadas: true };
  if (filter?.status?.length) apiFilter.status = filter.status;
  if (filter?.municipioIbge?.length) apiFilter.cidade = filter.municipioIbge;
  if (filter?.malhaId?.length) apiFilter.malha = filter.malhaId;
  return apiFilter;
};

/** Acima deste volume exibimos aviso de performance. */
export const MARKER_WARN_THRESHOLD = 2500;

/** Altura compartilhada entre mapa e painel lateral. */
export const MAP_ROW_HEIGHT = {
  xs: 'calc(100vh - 320px)',
  md: 'calc(100vh - 280px)',
};
export const MAP_ROW_MIN_HEIGHT = 420;

/** Zoom mínimo ao focar uma NSIR selecionada (lista ou marcador). */
export const MAP_MARKER_FOCUS_ZOOM = 15;

export const KPI_KEYS = {
  TOTAL: 'TOTAL',
  ANOMALIAS: 'ANOMALIAS',
  AGUARDANDO: 'AGUARDANDO',
  EM_INSPECAO: 'EM_INSPECAO',
  FINALIZADAS: 'FINALIZADAS',
  GPS_ERRORS: 'GPS_ERRORS',
};

export const PRESET_KEYS = {
  ANOMALIAS: 'anomalias',
  BACKLOG: 'backlog',
  GPS: 'gps',
  COMPLETO: 'completo',
};

export const KPI_COLORS = {
  [KPI_KEYS.TOTAL]: 'primary',
  [KPI_KEYS.ANOMALIAS]: 'error',
  [KPI_KEYS.AGUARDANDO]: 'info',
  [KPI_KEYS.EM_INSPECAO]: 'warning',
  [KPI_KEYS.FINALIZADAS]: 'success',
  [KPI_KEYS.GPS_ERRORS]: 'error',
};

export const FINALIZADAS_STATUSES = [
  Status.INSPECAO_FINALIZADA,
  Status.INSPECAO_ENVIADA_PARCIAL,
  Status.INSPECAO_ENVIADA_COM_SUCESSO,
  Status.DIGITACAO_FINALIZADA,
];

export const BACKLOG_STATUSES = [
  Status.AGUARDANDO_INSPECAO,
  Status.EM_INSPECAO,
  Status.EM_CRIACAO,
];

export const PRESET_LABELS = {
  [PRESET_KEYS.ANOMALIAS]: 'Foco anomalias',
  [PRESET_KEYS.BACKLOG]: 'Backlog inspeção',
  [PRESET_KEYS.GPS]: 'Erros GPS',
  [PRESET_KEYS.COMPLETO]: 'Visão completa',
};
